var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 9.33333V4H3.16724V28H29.8339V9.33333H16.5006ZM8.50057 25.3333H5.8339V22.6667H8.50057V25.3333ZM8.50057 20H5.8339V17.3333H8.50057V20ZM8.50057 14.6667H5.8339V12H8.50057V14.6667ZM8.50057 9.33333H5.8339V6.66667H8.50057V9.33333ZM13.8339 25.3333H11.1672V22.6667H13.8339V25.3333ZM13.8339 20H11.1672V17.3333H13.8339V20ZM13.8339 14.6667H11.1672V12H13.8339V14.6667ZM13.8339 9.33333H11.1672V6.66667H13.8339V9.33333ZM27.1672 25.3333H16.5006V22.6667H19.1672V20H16.5006V17.3333H19.1672V14.6667H16.5006V12H27.1672V25.3333ZM24.5006 14.6667H21.8339V17.3333H24.5006V14.6667ZM24.5006 20H21.8339V22.6667H24.5006V20Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporation);
export default __webpack_public_path__ + "static/media/corporation.03a1500031dedae132e3627e3da9c7b7.svg";
export { ForwardRef as ReactComponent };